import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import {EditorState, ContentState, convertToRaw} from 'draft-js';
import {Editor} from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import PortalUserContext, { UserType } from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  editor: {
    border: '1px solid #ccc',
    padding: 15,
    height: 400,
    width: "100%"
  },
  wrapper: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  value?: string;
  readonly?: boolean;
  onTextChange: any;
  minHeight?: number;
  allowHeader?: boolean;
  allowBlockquote?: boolean;
  allowCodeblock?: boolean;
  autoFocus?: boolean;
  toolbarOptions?: any;
  toolbarOnFocus?: boolean;
  toolbarCustomButtons?: Array<any>;
  containerStyle?: any;
}

type State = {
  editorState: any
};

const defaultToolbarOptions = {
  //options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'remove', 'history'],
  options: ['inline', 'link', 'image'],
}

class RichTextEditor extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      editorState: EditorState.createEmpty()
    };
  }

  editorContainer:any;

  componentDidMount() {
    const blocksFromHtml = htmlToDraft(this.props.value || '');
    const {contentBlocks, entityMap} = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    const editorState = EditorState.createWithContent(contentState);

    this.setState({
      editorState: editorState
    });
  }

  onEditorStateChange: Function = (editorState) => {
    this.setState({
      editorState
    });

    this.setState({editorState});

    if (this.props.onTextChange) {
      const e = {
        target: {
          value: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        }
      };
      this.props.onTextChange(e);
    }
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {toolbarOptions, toolbarOnFocus, toolbarCustomButtons} = this.props;
    const {editorState} = this.state;
        
    
    var to = toolbarOptions
    if(!to){
      to = defaultToolbarOptions
    }
        
    return (
      <div style={this.props.containerStyle}> 
        <Editor
          toolbarOnFocus={toolbarOnFocus}
          editorState={editorState}
          wrapperClassName={classes.wrapper}
          editorClassName={classes.editor}
          onEditorStateChange={this.onEditorStateChange}
          editorRef={(ref) => {
            this.editorContainer = ref;
          }}
          toolbar={to}
          toolbarCustomButtons={toolbarCustomButtons}
        />
      </div>
    );
  }
}

export default withStyles(styles)(RichTextEditor);
